import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import {
  BgImage,
  ContactCTA,
  Header,
  Intro,
  NewsWidget,
  SustainabilityCTA,
} from "@prmf/site-components";
import accreditaions from "@prmf/site-components/assets/accreditations.json";
import { routes, t } from "@prmf/site-router";

export default function Accreditations() {
  return (
    <div>
      <Header
        title="Accreditations and certifications"
        image={t(routes.accreditations, "image")}
        bgColor="black"
        className="text-white"
      >
        <p>
          We are very proud of the standards we have achieved, and we believe
          that no other kitchen company offers you such high levels of
          commitment to first-class service and outstanding products.
        </p>
        <p>
          Maintaining these standards demonstrates consideration for our
          communities and the environment and respect for the materials we use.
        </p>
      </Header>
      <Intro
        bgColor="black"
        title="We are committed to our employees, to optimising our environmental performance, acting responsibly with transparency, and we constantly strive to learn and be better."
      />
      <div className="container grid gap-10 py-20 sm:grid-cols-2 lg:grid-cols-4">
        {Object.values(accreditaions)
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((a) => (
            <Disclosure
              as="article"
              key={a.title}
              className="space-y-4 text-xs text-gray-700"
            >
              <Disclosure.Button as="div" className="cursor-pointer space-y-4">
                {({ open }) => (
                  <>
                    <BgImage
                      className="mx-auto aspect-[4/3] rounded border bg-white !bg-[length:80%_80%]"
                      src={a.image}
                    />
                    <h3 className="flex justify-between border-b border-gray-300 pb-2 font-bold">
                      {a.title}
                      {open ? (
                        <MinusIcon className="w-h4 h-4" />
                      ) : (
                        <PlusIcon className="h-4 w-4" />
                      )}
                    </h3>
                  </>
                )}
              </Disclosure.Button>
              <Disclosure.Panel as="p" unmount={false}>
                {a.text}
              </Disclosure.Panel>
            </Disclosure>
          ))}
      </div>
      <SustainabilityCTA />
      <ContactCTA />
      <NewsWidget />
    </div>
  );
}
